/**
 * BCP 47 script codes for right-to-left scripts.
 *
 * @see https://en.wikipedia.org/wiki/Right-to-left_script
 */
const rtlScripts = new Set([
    // Current Scripts
    // NOTE: some of these are less prevalent like Mende which is only used by about 500 people.
    'Arab',
    'Hebr',
    'Thaa',
    'Syrc',
    'Syre',
    'Syrj',
    'Syrn',
    'Mand',
    'Samr',
    'Mend',
    'Nkoo',
    'Adlm',
    'Rohg',
    'Yezi', // Yazidi Alphabet (Kurdish, Kurmanji dialect)
    // NOTE: I didn't include ancient scripts. Most of the ones I tested had the following issues:
    // - textInfo.direction was 'ltr' in browsers that supported it
    // - some have usage of both 'ltr' and 'rtl' directions (ex: Ital or "Old Italian")
]);
export function getTextDirFromLocale(locale) {
    var _a, _b, _c;
    const maximizedLocale = locale.maximize();
    // NOTE: most of the browser testing tried showed that if textInfo was supported, it would be available
    //     | without a maximize() call. But, we can just check this again in case there is an implementation
    //     | difference missed (maybe for specific inputs).
    const textInfo = (_a = locale.textInfo) !== null && _a !== void 0 ? _a : maximizedLocale.textInfo;
    if (textInfo === null || textInfo === void 0 ? void 0 : textInfo.direction) {
        return textInfo === null || textInfo === void 0 ? void 0 : textInfo.direction;
    }
    // checking against the script tag is probably better than checking against lang tag.
    const isRtl = rtlScripts.has((_c = (_b = locale.script) !== null && _b !== void 0 ? _b : maximizedLocale.script) !== null && _c !== void 0 ? _c : '');
    return isRtl ? 'rtl' : 'ltr';
}
export function isValidLocale(localeStr) {
    try {
        // constructor will throw if the locale is not valid.
        new Intl.Locale(localeStr);
        return true;
    }
    catch (_a) {
        return false;
    }
}
